import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

const URL_PATTERNS = [
  'enum',
  'currencies',
  'industries',
  'segments',
  'countries',
  'categories'
];

export const enumInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);

  const urlLower = req.url.toLowerCase();
  const shouldIntercept = URL_PATTERNS.some(pattern =>
    urlLower.includes(pattern.toLowerCase())
  );

  if (shouldIntercept) {
    const currentLang = translateService.getCurrentLang();

    if (currentLang && !req.params.has('lang')) {
      const params = req.params.set('lang', currentLang);
      const clonedRequest = req.clone({params});
      return next(clonedRequest);
    }
  }

  return next(req);
};
